import React from "react";
import { observer } from "mobx-react-lite";
import { Col, Form, Row } from "react-bootstrap";
import type { ViewComponent } from "@frui.ts/views";
import FakeInput from "@edaz/edazkit/controls/FakeInput";
import { formatAmount, formatDate } from "utils/localizations";
import Section from "../../../common/section";
import type DistributorRefundDetailViewModel from "viewModels/finance/refundApprovals/distributorRefunds/distributorRefundDetailViewModel";
import type DistributorPaymentRequestResponse from "../../../../entities/distributorPaymentRequestResponse";

const DistributorRefundOrderSection: ViewComponent<DistributorRefundDetailViewModel> = observer(({ vm }) => {
  return (
    <Section title={vm.translate("distributorRefundDetail")} context={vm.item.id}>
      <Row>
        <Form.Group as={Col} md={8} lg={4} className="mb-3">
          <Form.Label>{vm.translateAttribute("distributorName")}</Form.Label>
          <FakeInput target={vm.item} property="distributorName" />
        </Form.Group>
        <Form.Group as={Col} md={8} lg={4} className="mb-3">
          <Form.Label>{vm.translateAttribute("distributorPaymentRequest")}</Form.Label>
          <FakeInput
            target={vm.item}
            property="distributorPaymentRequest"
            valueFormatter={(distributorPaymentRequest: DistributorPaymentRequestResponse) => {
              const value: DistributorPaymentRequestResponse = distributorPaymentRequest;
              return `${value.variableSymbol} -  ${formatDate(value.validSinceDate)} - ${vm.translateRequestType(value.type)}`;
            }}
          />
        </Form.Group>
        <Form.Group as={Col} md={4} lg={4} className="mb-3">
          <Form.Label>{vm.translateAttribute("variableSymbol")}</Form.Label>
          <FakeInput target={vm.item} property="variableSymbol" />
        </Form.Group>
        <Form.Group as={Col} md={8} lg={8} className="mb-3">
          <Form.Label>{vm.translateAttribute("refundReason")}</Form.Label>
          <FakeInput target={vm.item} property="refundReason" />
        </Form.Group>
        <Form.Group as={Col} md={4} lg={4} className="mb-3">
          <Form.Label>{vm.translateAttribute("refundAmount")}</Form.Label>
          <FakeInput target={vm.item} property="refundAmount" valueFormatter={(price: number) => formatAmount(price)} />
        </Form.Group>
      </Row>
    </Section>
  );
});

export default DistributorRefundOrderSection;
